import clsx from 'clsx';
import { memo, useCallback } from 'react';

const controlStyle = {
	height: '2.8em',
	width: '2.8em',
};

/**
 * Shared arrow-control button props used by previous/next controls.
 */
interface ControlProps {
	arrow?: string | null;
	onPress?: () => void;
	label?: string;
	className?: string | null;
	disabled?: boolean;
	light?: boolean;
}

/**
 * Renders a reusable SVG arrow button for gallery navigation.
 */
function Control({
	arrow = null,
	onPress,
	label = '',
	className = null,
	disabled = false,
	light: _light = false,
}: ControlProps) {
	const onButtonPress = useCallback(() => {
		onPress?.();
	}, [onPress]);

	return (
		<button
			type="button"
			className={clsx('gallery-control', className)}
			onClick={onButtonPress}
			disabled={disabled}
			aria-label={label}
		>
			<svg
				viewBox="0 0 18 18"
				role="presentation"
				focusable="false"
				aria-hidden="true"
				className="gallery-control-icon"
				style={controlStyle}
			>
				<path d={arrow || ''} fillRule="evenodd" />
			</svg>
		</button>
	);
}

const MemoizedControl = memo(Control);

export { MemoizedControl as Control };

/**
 * @deprecated Use named import instead: `import { Control } from './control'`.
 * Default export will be removed in the next major version.
 */
export default MemoizedControl;
